import { Serializable } from "@/core/generated/api/decorators/serializable_decorator"
import { FileAttachment } from "../customer/models/fileAttachment"
import { TaskNoteModel } from "./taskNoteModel"
import { IsISO8601, IsNotEmpty, ValidateNested } from "class-validator"
import { OnboardingRequirementModel } from "./rfs/onboardingRequirementModel"
import {
  IsDateAfter,
  IsRelatedDateAfter,
} from "../core/utils/validators/IsOnlyOneFIlled"
import { IsBeforeRelatedDate } from "../core/utils/validators/isBeforeRelatedDate"
import { RFSCustomType } from "../active/constants/rfsCustomType"
import { TaskKanbanStatus } from "../core/constants/taskKanbanStatus"
import { TaskStatus } from "../constants/taskStatus"
import { EngagementType } from "../active/constants/engagementType"

@Serializable
export class ProposalBaseModel {
  uid: string = ""
  @IsNotEmpty({
    message: "common:form.errors.empty",
    groups: ["rfs"],
  })
  name: string = ""
  caseNumber: string = ""
  description: string = ""
  state: TaskStatus | "" = ""
  kanbanStatus: TaskKanbanStatus = 0
  @IsISO8601(
    {
      strict: true,
      strictSeparator: true,
    },
    {
      message: "common:form.errors.empty",
      groups: ["rfs"],
    },
  )
  @IsDateAfter(new Date(), {
    message: "create_proposal:dates.deadline_after_today",
    groups: ["rfs"],
  })
  @IsBeforeRelatedDate("startDate", {
    message: "create_proposal:dates.deadline_before_start_date",
    groups: ["rfs"],
  })
  internalDeadline: string = ""
  maxNumberCandidates: number = 0
  workplace: string = ""
  @IsISO8601(
    {
      strict: true,
      strictSeparator: true,
    },
    {
      message: "common:form.errors.empty",
      groups: ["rfs"],
    },
  )
  startDate: string = ""
  @IsISO8601(
    {
      strict: true,
      strictSeparator: true,
    },
    {
      message: "common:form.errors.empty",
      groups: ["rfs"],
    },
  )
  @IsRelatedDateAfter("startDate", {
    message: "create_proposal:details.end_date_after_start_date",
    groups: ["rfs"],
  })
  endDate: string = ""
  isContinued: boolean = false
  intermediateSale: boolean = false
  acceptancePeriod: string = ""
  customerId: string = ""
  customerName: string = ""
  extensionMonths: number = 0
  version: number = 0
  subtitle: string = ""
  numHoursWeek: number = 0
  customType: RFSCustomType = RFSCustomType.Standard
  assignmentId: string = ""
  files: FileAttachment[] = []
  notes: TaskNoteModel[] = []
  @ValidateNested({
    groups: ["rfs", "access_card"],
  })
  onboardingRequirements: OnboardingRequirementModel =
    new OnboardingRequirementModel()
  engagementType: EngagementType = EngagementType.TimeAndMaterial

  constructor(init?: Partial<ProposalBaseModel>) {
    Object.assign(this, init)
  }
}
